<div class="header-left">
  <!-- Logo -->
  <a routerLink="/home" class="header-logo">
    <img src="img/greatday_logo.svg" alt="GreatDay Care" class="logo-svg">
  </a>
</div>

<!-- Navigation - Desktop only -->
<div class="header-center desktop-only">
  <nav class="nav-links">
    <a routerLink="/home" routerLinkActive="active" class="nav-link">{{ 'sidenav.navigation.home' | translate }}</a>
    <a routerLink="/settings" routerLinkActive="active" class="nav-link">{{ 'sidenav.navigation.settings' | translate }}</a>
  </nav>
</div>

<div class="header-right">
  <!-- Language selector button - Desktop -->
  <div class="language-selector desktop-only">
    <button class="language-button" [matMenuTriggerFor]="languageMenu" #languageTrigger="matMenuTrigger" type="button">
      <span class="language-flag">{{ getCurrentLanguageOption()?.flag }}</span>
      <iconify-icon [icon]="languageTrigger.menuOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'" class="chevron-icon"></iconify-icon>
    </button>
    <mat-menu #languageMenu="matMenu" class="language-menu">
      @for (option of languageOptions(); track option.value) {
        <button 
          mat-menu-item 
          class="language-menu-item"
          [class.selected]="currentLanguage() === option.value"
          (click)="onLanguageSelect(option.value)">
          <span class="language-flag">{{ option.flag }}</span>
          <span class="language-label">{{ option.label }}</span>
        </button>
      }
    </mat-menu>
  </div>

  <!-- Language selector button - Mobile -->
  <div class="language-selector mobile-only">
    <button class="language-button" [matMenuTriggerFor]="languageMenuMobile" #languageTriggerMobile="matMenuTrigger" type="button">
      <span class="language-flag">{{ getCurrentLanguageOption()?.flag }}</span>
      <iconify-icon [icon]="languageTriggerMobile.menuOpen ? 'mdi:chevron-up' : 'mdi:chevron-down'" class="chevron-icon"></iconify-icon>
    </button>
    <mat-menu #languageMenuMobile="matMenu" class="language-menu">
      @for (option of languageOptions(); track option.value) {
        <button 
          mat-menu-item 
          class="language-menu-item"
          [class.selected]="currentLanguage() === option.value"
          (click)="onLanguageSelect(option.value)">
          <span class="language-flag">{{ option.flag }}</span>
          <span class="language-label">{{ option.label }}</span>
        </button>
      }
    </mat-menu>
  </div>

  <!-- Mobile menu button -->
  <button class="menu-button mobile-only" type="button" (click)="onMenuClick()">
    <iconify-icon icon="mdi:menu"></iconify-icon>
  </button>
</div>
